import { useNavigate } from 'react-router-dom'
import type { DashboardTreatment } from '../../store/dashboardSlice'

interface TodaysTreatmentsProps {
  treatments: DashboardTreatment[]
}

export function TodaysTreatments({ treatments }: TodaysTreatmentsProps) {
  const navigate = useNavigate()

  return (
    <div data-testid="todays-treatments">
      <h2 className="text-[14px] font-medium text-text-primary mb-3">Today's Treatments</h2>

      {treatments.length === 0 ? (
        <p className="text-[12px] text-text-muted py-4 text-center" data-testid="todays-treatments-empty">
          No treatments scheduled for today
        </p>
      ) : (
        <div className="flex flex-col">
          {/* Header */}
          <div
            className="dash-tt-header grid items-center h-9 text-[11px] font-medium text-text-muted uppercase tracking-wide"
            style={{ gridTemplateColumns: '1fr 80px 1fr 120px 1fr' }}
          >
            <span className="px-2">Patient</span>
            <span className="px-2">Species</span>
            <span className="px-2">Owner</span>
            <span className="px-2">Type</span>
            <span className="px-2">Veterinarian</span>
          </div>

          {/* Rows */}
          {treatments.map((tx) => (
            <div
              key={tx.id}
              data-testid={`todays-treatment-row-${tx.id}`}
              onClick={() => navigate(`/treatments/${tx.id}`)}
              className="dash-tt-row grid items-center h-[44px] text-[13px] text-text-primary hover:bg-hover transition-colors duration-100 cursor-pointer"
              style={{ gridTemplateColumns: '1fr 80px 1fr 120px 1fr' }}
            >
              <span className="px-2 font-[500] truncate" data-testid="treatment-patient-name">
                {tx.patient_name}
              </span>
              <span className="px-2 text-[12px] text-text-secondary" data-testid="treatment-species">
                {tx.patient_species}
              </span>
              <span className="px-2 text-[12px] text-text-secondary truncate" data-testid="treatment-owner">
                {tx.owner_name}
              </span>
              <span className="px-2 text-[12px] text-text-secondary truncate" data-testid="treatment-type">
                {tx.treatment_type}
              </span>
              <span className="px-2 text-[12px] text-text-secondary truncate" data-testid="treatment-vet">
                {tx.veterinarian_name || '-'}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
